/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import {ROLES_KEY} from '@/graphql'
import i18n from '@/i18n'

const AllRoutes = [
  {
    url: i18n.t('menu.dashboad.url'),
    name: i18n.t('menu.dashboad.name'),
    slug: i18n.t('menu.dashboad.slug'),
    icon: 'HomeIcon',
    permission: ['menu_dashboard']

  },
  {
    url: i18n.t('menu.students.url'),
    name: i18n.t('menu.students.name'),
    slug: i18n.t('menu.students.slug'),
    icon: 'DatabaseIcon',
    permission: ['menu_students']
  },
  {
    url: i18n.t('menu.user_student_cameras.url'),
    name: i18n.t('menu.user_student_cameras.name'),
    slug: i18n.t('menu.user_student_cameras.slug'),
    icon: 'CameraIcon',
    permission: ['menu_user_students_cameras']

  },
  {
    url: i18n.t('menu.students_user.url'),
    name: i18n.t('menu.students_user.name'),
    slug: i18n.t('menu.students_user.slug'),
    icon: 'DatabaseIcon',
    permission: ['menu_user_students']
  },
  {
    url: i18n.t('menu.students_teacher.url'),
    name: i18n.t('menu.students_teacher.name'),
    slug: i18n.t('menu.students_teacher.slug'),
    icon: 'DatabaseIcon',
    permission: ['menu_teacher_students']

  },
  {
    url: i18n.t('menu.users.menu_path'),
    name: i18n.t('menu.users.name'),
    slug: i18n.t('menu.users.slug'),
    icon: 'UsersIcon',
    permission: ['menu_users']

  },
  {
    url: "/team",
    name: "Team",
    slug: "Team",
    icon: 'AwardIcon',
    permission: ['menu_teams']
  },
  // {
  //   url: '',
  //   name: 'Team',
  //   icon: 'AwardIcon',
  //   role: ['admin', 'kvsupport'],
  //   permission: ['menu_team'],
  //   submenu: [
  //     {
  //       url: i18n.t('menu.managers.url'),
  //       name: i18n.t('menu.managers.name'),
  //       slug: i18n.t('menu.managers.slug'),
  //       icon: 'AwardIcon',
  //       role: ['center', 'admin', 'kvsupport'],
  //       permission: ['menu_team_managers']
  //     },
  //     {
  //       url: i18n.t('menu.admins.url'),
  //       name: i18n.t('menu.admins.name'),
  //       slug: i18n.t('menu.admins.slug'),
  //       icon: 'UsersIcon',
  //       role: ['admin'],
  //       permission: ['menu_team_admins']
  //     },
  //     {
  //       url: i18n.t('menu.teachers.url'),
  //       name: i18n.t('menu.teachers.name'),
  //       slug: i18n.t('menu.teachers.slug'),
  //       icon: 'UserIcon',
  //       role: ['center', 'admin', 'kvsupport'],
  //       permission: ['menu_team_teachers']
  //     }
  //   ]
  // },
  // {
  //   url: '',
  //   name: 'Team',
  //   icon: 'AwardIcon',
  //   role: ['center'],
  //   permission: [],
  //   submenu: [
  //     {
  //       url: i18n.t('menu.managers.url'),
  //       name: i18n.t('menu.managers.name'),
  //       slug: i18n.t('menu.managers.slug'),
  //       icon: 'AwardIcon',
  //       role: ['center', 'admin', 'kvsupport'],
  //       permission: [],
  //     },
  //     {
  //       url: i18n.t('menu.teachers.url'),
  //       name: i18n.t('menu.teachers.name'),
  //       slug: i18n.t('menu.teachers.slug'),
  //       icon: 'UserIcon',
  //       role: ['center', 'admin', 'kvsupport'],
  //       permission: [],
  //     }
  //   ]
  // },
  {
    url: i18n.t('menu.incidents.menu_path'),
    name: i18n.t('menu.incidents.name'),
    slug: i18n.t('menu.incidents.slug'),
    icon: 'GridIcon',
    role: ['admin', 'manager', 'kvsupport', 'center'],
    permission: ['menu_incidents']
  },
  {
    url: i18n.t('menu.tickets.menu_path'),
    name: i18n.t('menu.tickets.name'),
    slug: i18n.t('menu.tickets.slug'),
    icon: 'CheckSquareIcon',
    role: ['admin', 'manager', 'kvsupport', 'center'],
    permission: ['menu_tickets']
  },
  {
    url: i18n.t('menu.messagings.url'),
    name: i18n.t('menu.messagings.name'),
    icon: 'MessageSquareIcon',
    role: ['admin'],
    permission: ['menu_message'],
    submenu: [
      {
        url: i18n.t('menu.announcements.url'),
        name: i18n.t('menu.announcements.name'),
        slug: i18n.t('menu.announcements.slug'),
        permission: ['menu_message_announcements']
      },
      {
        url: i18n.t('menu.chat.url'),
        name: i18n.t('menu.chat.name'),
        slug: i18n.t('menu.chat.slug'),
        permission: ['menu_message_alerts']
      },
      {
        url: i18n.t('menu.alerts.url'),
        name: i18n.t('menu.alerts.name'),
        slug: i18n.t('menu.alerts.slug'),
        permission: ['menu_message_alertlogs']
      },
      {
        url: i18n.t('menu.newsletters.url'),
        name: i18n.t('menu.newsletters.name'),
        slug: i18n.t('menu.newsletters.slug'),
        role: ['admin', 'center', 'manager'],
        permission: ['menu_message_newsletters']
      },
      {
        url: i18n.t('menu.templates.url'),
        name: i18n.t('menu.templates.name'),
        slug: i18n.t('menu.templates.slug'),
        role: ['admin', 'center'],
        permission: ['menu_message_newsletter_templates']
      }
    ]
  },
  // {
  //   url: i18n.t('menu.messagings.url'),
  //   name: i18n.t('menu.messagings.name'),
  //   icon: 'MessageSquareIcon',
  //   role: ['manager', 'kvsupport', 'center'],
  //   permission: [],
  //   submenu: [
  //     {
  //       url: i18n.t('menu.announcements.url'),
  //       name: i18n.t('menu.announcements.name'),
  //       slug: i18n.t('menu.announcements.slug'),
  //       permission: [],
  //     },
  //     {
  //       url: i18n.t('menu.chat.url'),
  //       name: i18n.t('menu.chat.name'),
  //       slug: i18n.t('menu.chat.slug'),
  //       permission: [],
  //     },
  //     {
  //       url: i18n.t('menu.alerts.url'),
  //       name: i18n.t('menu.alerts.name'),
  //       slug: i18n.t('menu.alerts.slug'),
  //       permission: [],
  //     },
  //     {
  //       url: i18n.t('menu.newsletters.url'),
  //       name: i18n.t('menu.newsletters.name'),
  //       slug: i18n.t('menu.newsletters.slug'),
  //       permission: [],
  //     },
  //   ]
  // },
  {
    url: i18n.t('menu.reports.url'),
    name: i18n.t('menu.reports.name'),
    role: ['center', 'admin', 'kvsupport'],
    permission: ['menu_report'],
    // tag: '2',
    // tagColor: 'warning',
    icon: 'FileIcon',
    submenu: [
      {
        url: i18n.t('menu.daily_logins.url'),
        name: i18n.t('menu.daily_logins.name'),
        slug: i18n.t('menu.daily_logins.slug'),
        permission: ['menu_report_login_report']
      },
      {
        url: i18n.t('menu.daily_watch_time.url'),
        name: i18n.t('menu.daily_watch_time.name'),
        slug: i18n.t('menu.daily_watch_time.slug'),
        permission: ['menu_report_watchtime_report']
      },
      {
        url: i18n.t('menu.logs.url'),
        name: i18n.t('menu.logs.name'),
        slug: i18n.t('menu.logs.slug'),
        permission: ['menu_report_logs']
      }
    ]
  },
  {
    url: i18n.t('menu.settings.url'),
    name: i18n.t('menu.settings.name'),
    role: ['center', 'admin', 'kvsupport'],
    icon: 'SettingsIcon',
    permission: ['menu_setting'],
    submenu: [
      {
        url: i18n.t('menu.locations.url'),
        name: i18n.t('menu.locations.name'),
        slug: i18n.t('menu.locations.slug'),
        permission: ['menu_setting_locations']
      },
      {
        url: i18n.t('menu.programs.url'),
        name: i18n.t('menu.programs.name'),
        slug: i18n.t('menu.programs.slug'),
        permission: ['menu_setting_programs']
      },
      // {
      //   url: i18n.t('menu.cameras.url'),
      //   name: i18n.t('menu.cameras.name'),
      //   slug: i18n.t('menu.cameras.slug'),
      // },
      {
        url: i18n.t('menu.schedules.url'),
        name: i18n.t('menu.schedules.name'),
        slug: i18n.t('menu.schedules.slug'),
        permission: ['menu_setting_schedules']
      },
      {
        url: i18n.t('menu.theme_customizer.url'),
        name: i18n.t('menu.theme_customizer.name'),
        slug: i18n.t('menu.theme_customizer.slug'),
        permission: ['menu_setting_theme_settings'],
      },
      {
        url: i18n.t('menu.on_boarding.url'),
        name: i18n.t('menu.on_boarding.name'),
        slug: i18n.t('menu.on_boarding.slug'),
        permission: ['menu_setting_on_boarding'],
      },
      {
        url: i18n.t('menu.school_profile.url'),
        name: i18n.t('menu.school_profile.name'),
        slug: i18n.t('menu.school_profile.slug'),
        permission: ['menu_setting_school_profile'],
      },
      {
        url: '/permissions',
        name: 'Permissions Management',
        slug: 'Permissions Management',
        role: ['admin'],
        permission: ['menu_setting_permissions_managment'],
        role: ['center', 'admin', 'kvsupport'],
      },
      {
        url: '/images',
        name: 'Images',
        slug: 'Images',
        role: ['admin'],
        permission: ['menu_setting_images']
      },
      {
        url: '/sites',
        name: 'Websites Builder',
        slug: 'Websites Builder',
        role: ['admin'],
        permission: ['menu_setting_websites_builder'],
        role: ['admin'],
      },
    ]
  }
  // {
  //   url: i18n.t('menu.chat.url'),
  //   name: i18n.t('menu.chat.name'),
  //   slug: i18n.t('menu.chat.slug'),
  //   icon: 'MessageSquareIcon',
  //   role: ['teacher'],
  //   permission: ['read_teacher_chat'],
  // }
]

let user_roles = []
const permissions = []
let user_permissions = []

const Menu = []
let user_roles_array = []

if (localStorage.getItem(ROLES_KEY)) {

  // console.log(localStorage.getItem(ROLES_KEY))
  user_roles = localStorage.getItem(ROLES_KEY)
  user_permissions = JSON.parse(user_roles).map(function (value, index) { return value['permissions'] })
  const result = Object.keys(user_permissions).map((key) => [Number(key), user_permissions[key]])
  user_permissions = result[0][1]
  for (let index = 0; index < user_permissions.length; index++) {
    permissions.push(user_permissions[index].name)
  } 
  user_permissions = permissions
  user_roles_array = JSON.parse(user_roles).map(function (value, index) { return value['name'] })
  // console.log(user_roles_array)

}


for (const i in AllRoutes) {
  // console.log( AllRoutes[i].permission)
  // console.log( AllRoutes[i].role)
 
  // if (user_roles_array.some(value =>  AllRoutes[i].role.includes(value))) {
  //   Menu.push(AllRoutes[i])
  // }
  if (user_permissions.some(value =>  AllRoutes[i].permission.includes(value))) {
    if (AllRoutes[i].submenu) {
      const submenu = []
      for (const j in AllRoutes[i].submenu) {
        if (user_permissions.some(value =>  AllRoutes[i].submenu[j].permission.includes(value))) submenu.push(AllRoutes[i].submenu[j])
      }
      AllRoutes[i]['submenu'] = submenu
    }
    Menu.push(AllRoutes[i])
  }
}
export default
Menu

